import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import { toast } from "react-toastify";
import { profileActivityJava } from "../../../javaAxiosConfig";

import CommonContactModal from "./CommonContactModal";

import { ToastContainer } from "react-toastify";

import axiosInsatnace, { chatStatus } from "../../../asiosConfig";

import { useProfileActions } from "../../../profileActions/useProfileActions";
import { getProfileActionType } from "../../../profileActions/actionResolver";
import { ACTION_CONFIG } from "../../../profileActions/actionConfig";

import { contactViewJava, searchProfilesJava } from "../../../javaAxiosConfig";
import { useLocation, useNavigate } from "react-router-dom";

import "../../UserComponent/MatchProfileContainer.css";

import { Fragment } from "react";

import defaultImage from "../../../images/no-photo.png";

import femaleImg from "../../../images/female-default-profile.png";
import maleImg from "../../../images/Male-default-profile.png";

import { Box, CircularProgress, useMediaQuery } from "@mui/material";

import { IoMdUndo } from "react-icons/io";

import educIcon from "../../../images/educIcon.png";
import jobIcon from "../../../images/jobIcon.png";
import heightIcon from "../../../images/heightIcon.png";
import Profileicon from "../../../images/Profileicon.png";
import goldIcon from "../../../images/gold.png";
import platinumIcon from "../../../images/platinum.png";
import diamondIcon from "../../../images/diamond.png";
// import premiumPlusIcon from "../../../images/premiumPlus.png";
// import tillUMarryIcon from "../../../images/marry.png";

import viewPhotoIcon from "../../../images/view-photo-icon.svg";
import premiumPlusIcon from "../../../images/crownIconPremium.svg";
import tillUMarryIcon from "../../../images/assistedVip.png";

import BlueVerified from "../../../images/BlueVerified.png";


import popupImg from "../../../images/popup_design.png";
import TimeDateIcon from "../../../images/TimeDateIcon.png";
import shortlistIcon from "../../../images/shortlistIcon.png";
import SendInterest from "../../../images/intrest-icon.svg";
import IgnoreIcon from "../../../images/IgnoreIcon.png";
import ContactIcon from "../../../images/ContactIcon.png";
import AcceptInterestIcon from "../../../images/AcceptInterestIcon.png";
import BookMarkRemoveIcon from "../../../images/BookmarkIcon.png";
import DeclinedInterestIcon from "../../../images/DelinedIcon.png";
import sendRemidIcon from "../../../images/sendReminder.png";
import ChatIcon from "../../../images/messageNow.svg";
import RemoveIgnoreIcon from "../../../images/RemoveIgnoreIcon.png";
import { useTheme } from "@mui/material/styles";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../services/firebaseConfig";
import MessengerModal from "../../MessengerModel";

import BookmarkIcon from "../../../images/bookmark-icon.svg";
import BookmarkIconFilled from "../../../images/bookmarkIconFilled.svg";

import Popup from "../../Popup";

const packageIcons = {
  Gold: goldIcon,
  Platinum: platinumIcon,
  Diamond: diamondIcon,
  Premium: premiumPlusIcon,
  "Premium+": premiumPlusIcon,
  Assisted: tillUMarryIcon,
};

export const SearchResult = () => {
  const [result, setResult] = useState([]);
  // const [loading, setLoading] = useState(false);

  const [pageLoading, setPageLoading] = useState(false); // pagination only
  const { handleAction, handleIgnore, isActionLoading } = useProfileActions({
    setProfiles: setResult,
  });

  const gender = localStorage.getItem("gender");

  const defaultImage = gender === "F" ? maleImg : femaleImg;

  const [bookmarkAnimating, setBookmarkAnimating] = useState(null);

  const [contactInfo, setContactInfo] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);

  const [isHydrated, setIsHydrated] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ must come BEFORE payloadKey/storageKey
  const { searchPayload } = location.state || {};

  // stable key per searchPayload (works for ANY page)
  const payloadKey = JSON.stringify(searchPayload || {});
  const storageKey = `SR_RESTORE_${btoa(unescape(encodeURIComponent(payloadKey)))}`;

  const restoredOnceRef = useRef(false);
  const skipNextFetchRef = useRef(false);
  const inFlightPagesRef = useRef(new Set()); // ✅ stops duplicate fetch logs

  const lastMatchElementRef = useRef(null);

  // const { searchResult } = location.state || {};

  const token = localStorage.getItem("token");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const username = localStorage.getItem("username");
  const [openMessengerModal, setOpenMessengerModal] = useState(false);

  const observerRef = useRef(null);

  const normalizeProfile = (p) => ({
    ...p,

    // ✅ IMPORTANT: normalize username
    username: p.username || p.register_id || p.userName || "",

    /* ===== IMAGE ===== */

    photo: p.profilePhoto || "",

    /* ===== NAME ===== */
    name: p.name || "",

    /* ===== LAST SEEN ===== */
    last_login: p.lastSeen && p.lastSeen.trim() !== "" ? p.lastSeen : null,
    last_viewed: p.date_viewed || null,

    /* ===== LOCATION ===== */
    city:
      p.nativeCity && p.nativeState
        ? `${p.nativeCity}, ${p.nativeState}`
        : p.nativeCity || p.nativeState || null,

    /* ===== MEMBERSHIP ===== */
    membership_type: p.membershipType || "Free",

    // photo count
    photoCount: p.photoCount || 0,

    /* ===== INTEREST ACCEPTED ===== */
    interestAccepted: p.interest_i_accept === true,

    /* ===== BOOKMARK / IGNORE ===== */
    bookmarked: p.isShortlisted,
    isIgnored: p.isIgnored,
    ignored: p.isIgnored ? { member_id: p.id } : null,

    occupation: p.occupation || null,
income: p.income || null,
residingCity: p.residingCity || null,

age: p.age || null,
height: p.height || null,
maritalStatus: p.maritalStatus || null,

caste: p.caste || null,
religion: p.religion || null,

education: p.education || null,
nativeCity: p.nativeCity || null,
nativeState: p.nativeState || null,

verifiedStatus: p.verifiedStatus === true,

    /* ===== INTEREST STATES ===== */
    interestSent: p.interestSent === true,
    interestReceived: p.interestReceived === true,

    send: p.interestSent ? { accept: 0, reject: 0 } : null,
    received: p.interestReceived
      ? { sender: p.id, accept: 0, reject: 0 }
      : null,
  });

  // const isActionLoading = (profileId, action) =>
  // actionLoading.profileId === profileId &&
  // actionLoading.action === action;

  const handleViewPhoto = async (profile) => {
    try {
      await profileActivityJava({
        user_id: profile.id,
        response_type: "view_photo",
      });

      navigate(`/view-user-photos/${profile.id}`);
    } catch (err) {
      toast.error("Unable to load photos");
    }
  };

  const handleToggleBookmark = async (profile, e) => {
    e.stopPropagation();

    const isBookmarked = profile.bookmarked;
    setBookmarkAnimating(profile.id);

    // optimistic update
    setResult((prev) =>
      prev.map((p) =>
        p.id === profile.id ? { ...p, bookmarked: !isBookmarked } : p,
      ),
    );

    try {
      await axiosInsatnace.post("profile-activity", {
        token,
        user_id: profile.id,
        response_type: isBookmarked ? "remove_bookmark" : "bookmark",
      });
    } catch (err) {
      // rollback on failure
      setResult((prev) =>
        prev.map((p) =>
          p.id === profile.id ? { ...p, bookmarked: isBookmarked } : p,
        ),
      );
      showPopup("error", "Unable to update shortlist");
    } finally {
      setTimeout(() => setBookmarkAnimating(null), 300);
    }
  };

  // Utility function to check and filter duplicates
  const removeDuplicates = (newData) => {
    const uniqueIds = new Set(); // Set to track unique IDs
    return newData.filter((item) => {
      // Check if the item ID is already in the Set
      if (uniqueIds.has(item.id)) {
        return false; // Skip duplicate
      } else {
        uniqueIds.add(item.id); // Add to Set
        return true; // Keep unique item
      }
    });
  };

  const [popupData, setPopupData] = useState({
    open: false,
    type: "",
    message: "",
  });

  const showPopup = (type, message) => {
    setPopupData({ open: true, type, message });
  };

  const handleClosePopup = () => {
    setPopupData((prev) => ({ ...prev, open: false }));
  };

  const fetchResult = async (page) => {
    setPageLoading(true);
    setError(null);

    try {
      const response = await searchProfilesJava({
        // ...searchResult,
        ...searchPayload,
        pagination: {
          page,
          limit: 5,
        },
      });

      if (response.data?.status) {
        const fetchedData = response.data.profiles || [];

        if (fetchedData.length === 0) {
          setHasMore(false);
        } else {
          // setResult((prev) => {
          //   const merged = [...prev, ...fetchedData];
          //   return removeDuplicates(merged);
          // });
          const normalized = fetchedData.map(normalizeProfile);

          setResult((prev) => {
            const merged = [...prev, ...normalized];
            return removeDuplicates(merged);
          });

          const total = response.data.pagination?.total || 0;
          if (page * 5 >= total) setHasMore(false);
        }
      } else {
        showPopup("error", "Failed to fetch search results");
      }
    } catch (err) {
      showPopup("error", "Error fetching search results");
    } finally {
      setPageLoading(false);
    }
  };

  // useEffect(() => {
  //   const raw = sessionStorage.getItem(storageKey);
  //   if (!raw) return;

  //   try {
  //     const saved = JSON.parse(raw);

  //     console.log("🔵 Restoring SearchResult from sessionStorage", {
  //       page: saved.page,
  //       resultLen: saved.result?.length,
  //       scrollY: saved.scrollY,
  //     });

  //     restoredOnceRef.current = true;
  //     skipNextFetchRef.current = true;

  //     setResult(saved.result || []);
  //     setPage(saved.page || 1);
  //     setHasMore(saved.hasMore ?? true);

  //     requestAnimationFrame(() => {
  //       requestAnimationFrame(() => {
  //         window.scrollTo(0, saved.scrollY || 0);
  //       });
  //     });
  //   } catch (e) {
  //     console.log("🔴 Failed to parse restore state", e);
  //     sessionStorage.removeItem(storageKey);
  //   }
  // }, [storageKey]);

  // Effect to handle fetching when page changes

  useLayoutEffect(() => {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) {
      setIsHydrated(true); // ✅ ALSO IMPORTANT (no saved state case)
      return;
    }

    try {
      const saved = JSON.parse(raw);

      restoredOnceRef.current = true;
      skipNextFetchRef.current = true;

      setResult(saved.result || []);
      setPage(saved.page || 1);
      setHasMore(saved.hasMore ?? true);

      window.scrollTo(0, saved.scrollY || 0);

      sessionStorage.removeItem(storageKey);

      setIsHydrated(true); // ✅ ADD THIS
    } catch (e) {
      sessionStorage.removeItem(storageKey);
      setIsHydrated(true); // ✅ ADD THIS
    }
  }, [storageKey]);

  useEffect(() => {
    // if we just restored, DO NOT wipe list
    if (restoredOnceRef.current) return;

    setResult([]);
    setPage(1);
    setHasMore(true);
  }, [payloadKey]);

  //   useEffect(() => {
  //   if (!searchPayload) return;
  //   if (!hasMore) return;

  //   fetchResult(page);
  // }, [page, searchPayload]);

  useEffect(() => {
    if (!searchPayload) return;
    if (!hasMore) return;

    // ✅ after restore, skip exactly one fetch
    if (skipNextFetchRef.current) {
      console.log("🟡 Skipping fetch after restore");
      skipNextFetchRef.current = false;
      return;
    }

    // ✅ prevent duplicate page fetch (StrictMode / rerenders)
    if (inFlightPagesRef.current.has(page)) {
      console.log("🟠 Duplicate fetch blocked for page:", page);
      return;
    }

    inFlightPagesRef.current.add(page);
    console.log("🟢 Fetching page:", page);

    (async () => {
      try {
        await fetchResult(page);
      } finally {
        inFlightPagesRef.current.delete(page);
      }
    })();
  }, [page, payloadKey, hasMore]);

  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !pageLoading) {
          setPage((prev) => prev + 1);
        }
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0,
      },
    );

    const currentRef = lastMatchElementRef.current;

    if (currentRef) {
      observerRef.current.observe(currentRef);
    }

    return () => {
      if (observerRef.current && currentRef) {
        observerRef.current.unobserve(currentRef);
      }
    };
  }, [result, hasMore, pageLoading]);

  const handleContactClick = async (profile) => {
    try {
      const response = await contactViewJava({
        toUserId: profile.id,
      });

      if (response.data?.status === true) {
        setContactInfo({
          type: "success",
          phone: response.data.message, // ✅ mobile number
          message: response.data.message, // ✅ used by modal
          username: profile.username, // ✅ REQUIRED
          photo: profile.photo, // ✅ REQUIRED
          fallbackPhoto: defaultImage,
        });
      } else {
        setContactInfo({
          type: "error",
          phone: null,
          message: response.data.message,
          username: profile.username,
          photo: profile.photo,
          fallbackPhoto: defaultImage,
        });
      }

      setOpenModal(true);
    } catch (error) {
      setContactInfo({
        type: "error",
        phone: null,
        message:
          error.response?.data?.message || "Failed to retrieve contact info",
        username: profile.username,
        photo: profile.photo,
        fallbackPhoto: defaultImage,
      });

      setOpenModal(true);
    }
  };

  // const handleContactClick = async (profile) => {
  //   try {
  //     const response = await contactViewJava({
  //       toUserId: profile.id, // ✅ ONLY ID
  //     });

  //     if (response.data?.status) {
  //       setContactInfo({
  //         ...response.data.data,
  //         fallbackPhoto: defaultImage,
  //         type: "success",
  //       });
  //       setOpenModal(true);
  //     } else {
  //       setContactInfo({
  //         type: "error",
  //         message: response.data.message,
  //         fallbackPhoto: defaultImage,
  //       });
  //       setOpenModal(true);
  //     }
  //   } catch (error) {
  //     setContactInfo({
  //       type: "error",
  //       message:
  //         error.response?.data?.message || "Failed to retrieve contact info",
  //       fallbackPhoto: defaultImage,
  //     });
  //     setOpenModal(true);
  //   }
  // };

  const FigmaButton = ({ label, icon, onClick, active = false }) => {
    return (
      <div
        className={`figma-btn ${active ? "active-btn" : ""}`}
        onClick={onClick}
      >
        <div className="figma-btn-bg" />
        <div className="figma-btn-content">
          <span>{label}</span>
          <img src={icon} alt={label} className="figma-btn-icon" />
        </div>
      </div>
    );
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const startChat = async (recipientId, profile) => {
    setOpenMessengerModal(true);
  };

  const getActionButton = (profile) => {
    const actionType = getProfileActionType(profile);
    const actions = ACTION_CONFIG[actionType] || [];

    return (
      <Box
        display="flex"
        className="action-container"
        justifyContent="space-between"
      >
        {actions.map((action) => {
          switch (action) {
            // case "SEND_INTEREST":
            //   return (
            //     <div
            //       key={action}
            //       className="figma-btn send-intrest-btn"
            //       onClick={(e) => {
            //         e.stopPropagation();
            //         handleAction(
            //           { user_id: profile.id, response_type: "interest" },
            //           "SEND_INTEREST",
            //           profile.id,
            //         );
            //       }}
            //     >
            //       <div className="figma-btn-bg" />
            //       <div className="figma-btn-content send-intrest">
            //         <span>Send Interest</span>
            //         <img src={SendInterest} className="figma-btn-icon" />
            //       </div>
            //     </div>
            //   );

            case "SEND_INTEREST":
              return (
                <div
                  key={action}
                  className="figma-btn send-intrest-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "SEND_INTEREST")) return;
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "interest" },
                      "SEND_INTEREST",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content send-intrest">
                    {isActionLoading(profile.id, "SEND_INTEREST") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Send Interest</span>
                        <img src={SendInterest} className="figma-btn-icon" />
                      </>
                    )}
                  </div>
                </div>
              );

            // case "SEND_REMINDER":
            //   return (
            //     <div
            //       key={action}
            //       className="figma-btn"
            //       onClick={(e) => {
            //         e.stopPropagation();
            //         handleAction(
            //           { user_id: profile.id, response_type: "send_reminder" },
            //           "Send Reminder",
            //         );
            //       }}
            //     >
            //       <div className="figma-btn-bg" />
            //       <div className="figma-btn-content">
            //         <span>Reminder</span>
            //         <img src={sendRemidIcon} className="figma-btn-icon" />
            //       </div>
            //     </div>
            //   );

            case "SEND_REMINDER":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "SEND_REMINDER")) return;
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "send_reminder" },
                      "SEND_REMINDER",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    {isActionLoading(profile.id, "SEND_REMINDER") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Reminder</span>
                        <img src={sendRemidIcon} className="figma-btn-icon" />
                      </>
                    )}
                  </div>
                </div>
              );

            case "ACCEPT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "ACCEPT")) return;
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "accept" },
                      "ACCEPT",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    {isActionLoading(profile.id, "ACCEPT") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Accept</span>
                        <img
                          src={AcceptInterestIcon}
                          className="figma-btn-icon"
                        />
                      </>
                    )}
                  </div>
                </div>
              );

            case "DECLINE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "DECLINE")) return;
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "reject" },
                      "DECLINE",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    {isActionLoading(profile.id, "DECLINE") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Decline</span>
                        <img
                          src={DeclinedInterestIcon}
                          className="figma-btn-icon"
                        />
                      </>
                    )}
                  </div>
                </div>
              );

            case "CHAT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    startChat(profile.username, profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Chat</span>
                    <img src={ChatIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "CONTACT":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleContactClick(profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Contact</span>
                    <img src={ContactIcon} className="figma-btn-icon" />
                  </div>
                </div>
              );

            case "IGNORE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    if (isActionLoading(profile.id, "IGNORE")) return;
                    e.stopPropagation();
                    handleIgnore(profile);
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    {isActionLoading(profile.id, "IGNORE") ? (
                      <CircularProgress size={18} />
                    ) : (
                      <>
                        <span>Ignore</span>
                        <img src={IgnoreIcon} className="figma-btn-icon" />
                      </>
                    )}
                  </div>
                </div>
              );

            case "REMOVE_IGNORE":
              return (
                <div
                  key={action}
                  className="figma-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAction(
                      { user_id: profile.id, response_type: "remove_ignore" },
                      "REMOVE_IGNORE",
                    );
                  }}
                >
                  <div className="figma-btn-bg" />
                  <div className="figma-btn-content">
                    <span>Remove Ignore</span>
                    <IoMdUndo className="figma-btn-icon" />
                  </div>
                </div>
              );

            default:
              return null;
          }
        })}
      </Box>
    );
  };

  //   const handleSearch = (profile) => {
  //   logEvent(analytics, "view_profile", {
  //     viewed_profile_id: profile.id,
  //     profile_viewer_id: localStorage.getItem("user"),
  //     platform: "web",
  //     timestamp: new Date().toISOString(),
  //   });

  //   navigate("/profile-view", {
  //     state: {
  //       username: profile.username,
  //       userId: profile.id,

  //       // ✅ SAVE SEARCH STATE
  //       previousSearchState: {
  //         result,
  //         page,
  //         hasMore,
  //         scrollY: window.scrollY,
  //       },
  //     },
  //   });
  // };

  const handleSearch = (profile) => {
    logEvent(analytics, "view_profile", {
      viewed_profile_id: profile.id,
      profile_viewer_id: localStorage.getItem("user"),
      platform: "web",
      timestamp: new Date().toISOString(),
    });

    const toSave = {
      result,
      page,
      hasMore,
      scrollY: window.scrollY,
      savedAt: Date.now(),
    };

    console.log("🟣 Saving SearchResult to sessionStorage", {
      page,
      resultLen: result.length,
      scrollY: window.scrollY,
    });

    sessionStorage.setItem(storageKey, JSON.stringify(toSave));

    navigate("/profile-view", {
      state: {
        username: profile.username,
        userId: profile.id,
      },
    });
  };

  const getDetails = (item) => {
    const details = [];

    if (item?.age) details.push(`${item.age} yr`);
    if (item?.height) details.push(item.height);
    if (item?.maritalStatus) details.push(item.maritalStatus);
    if (item?.city) details.push(item.city);
    if (item?.education) details.push(item.education);
    if (item?.occupation) details.push(item.occupation);
    if (item?.income) details.push(item.income);

    return details;
  };

  const MatchCard = ({
    item,
    defaultImage,
    isLast,
    lastMatchElementRef,
    handleSearch,
    handleToggleBookmark,
    bookmarkAnimating,
    getActionButton,
    handleViewPhoto,
  }) => {
    const safePhoto =
      item.photo && item.photo !== "null" && item.photo.trim() !== ""
        ? item.photo
        : defaultImage;

        const hasRow1 =
  item.occupation ||
  item.income ||
  item.residingCity;

const hasRow2 =
  item.age ||
  item.height ||
  item.maritalStatus;

const hasRow3 =
  item.caste ||
  item.religion;

const hasRow4 =
  item.education ||
  item.nativeCity ||
  item.nativeState;

    return (
      <div ref={isLast ? lastMatchElementRef : null}>
        <div
          className="match-card-container"
          style={{ cursor: "pointer" }}
          onClick={() => handleSearch(item)}
        >
          {/* IMAGE */}
          <div className="match-card-image-wrapper">
            {/* BLURRED BACKGROUND */}
            <div
              className="match-card-bg-fill"
              // style={{ backgroundImage: `url("${item.photo}")` }}
              style={{ backgroundImage: `url("${safePhoto}")` }}
            />

            {/* MAIN IMAGE */}
            <div
              className="match-card-main-bg"
              // style={{ backgroundImage: `url("${item.photo}")` }}
              style={{ backgroundImage: `url("${safePhoto}")` }}
            />

            {/* 🔹 VIEW PHOTO ICON */}
            {item.photoCount > 1 && (
              <div
                className="view-photo-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleViewPhoto(item);
                }}
              >
                <img src={viewPhotoIcon} alt="View Photos" />
                <span className="photo-count">{item.photoCount}</span>
              </div>
            )}

            {/* 🔹 PREMIUM BADGE */}
            {item.membership_type !== "Free" && (
              <div
                className={`premium-badge premium-${item.membership_type.toLowerCase()}`}
              >
                <img
                  style={{ width: "20px", height: "20px" }}
                  src={
                    item.membership_type === "Premium+" ||
                    item.membership_type === "Premium"
                      ? premiumPlusIcon
                      : item.membership_type === "Assisted"
                        ? tillUMarryIcon
                        : null
                  }
                  alt={item.membership_type}
                />
                <span
                  style={{
                    marginLeft: "2px",
                    fontSize: "11px",
                    fontWeight: 600,
                  }}
                >
                  {item.membership_type}
                </span>
              </div>
            )}

            {/* 🔹 ONLINE / LAST SEEN */}
            {item.last_login && (
              <>
                <div
                  className={`online-dot ${
                    item.last_login === "Online"
                      ? "online"
                      : "online-dot--offline"
                  }`}
                />
                <div
                  className={`online-status-badge ${
                    item.last_login === "Online"
                      ? "online"
                      : "online-status-badge--offline"
                  }`}
                >
                  {item.last_login === "Online"
                    ? "Online Available"
                    : `Last seen ${item.last_login}`}
                </div>
              </>
            )}
          </div>

          {/* CONTENT */}
          <div className="match-card-content">
            <div className="match-card-content-inner">
              <div className="match-card-top">


                {/* <div className="match-card-name-row">
                  <div className="match-card-name">{item.name}</div>

                  <div
                    className={`bookmark-btn ${
                      bookmarkAnimating === item.id ? "animate" : ""
                    }`}
                    onClick={(e) => handleToggleBookmark(item, e)}
                  >
                    <img
                      src={item.bookmarked ? BookmarkIconFilled : BookmarkIcon}
                      alt="Bookmark"
                      className="bookmark-svg"
                    />
                  </div>
                </div>

                <div className="match-card-details-grid">
                  {getDetails(item).map((detail, idx) => (
                    <div
                      className="match-card-detail-item"
                      key={`${detail}-${idx}`}
                    >
                      <span className="gradient-text">{detail}</span>
                    </div>
                  ))}
                </div> */}


                {/* USERNAME ABOVE NAME */}
{item.username && (
  <div className="match-card-username">
    ID - {item.username}
  </div>
)}

{/* NAME + VERIFIED + BOOKMARK */}
<div className="match-card-name-row">
  <div className="match-card-name">
    {item.name}
    {item.verifiedStatus === true && (
      <img
        src={BlueVerified}
        alt="Verified"
        className="verified-icon"
      />
    )}
  </div>

  <div
    className={`bookmark-btn ${
      bookmarkAnimating === item.id ? "animate" : ""
    }`}
    onClick={(e) => handleToggleBookmark(item, e)}
  >
    <img
      src={item.bookmarked ? BookmarkIconFilled : BookmarkIcon}
      alt="Bookmark"
      className="bookmark-svg"
    />
  </div>
</div>

{/* ROW 1 */}
{hasRow1 && (
  <div className="match-card-details-grid">
    {item.occupation && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.occupation}</span>
      </div>
    )}
    {item.income && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.income}</span>
      </div>
    )}
    {item.residingCity && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.residingCity}</span>
      </div>
    )}
  </div>
)}

{/* ROW 2 */}
{hasRow2 && (
  <div className="match-card-details-grid">
    {item.age && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.age} Years</span>
      </div>
    )}
    {item.height && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.height}</span>
      </div>
    )}
    {item.maritalStatus && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.maritalStatus}</span>
      </div>
    )}
  </div>
)}

{/* ROW 3 */}
{hasRow3 && (
  <div className="match-card-details-grid">
    {item.caste && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.caste}</span>
      </div>
    )}
    {item.religion && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.religion}</span>
      </div>
    )}
  </div>
)}

{/* ROW 4 */}
{hasRow4 && (
  <div className="match-card-details-grid">
    {item.education && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.education}</span>
      </div>
    )}
    {item.nativeCity && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.nativeCity}</span>
      </div>
    )}
    {item.nativeState && (
      <div className="match-card-detail-item">
        <span className="gradient-text">{item.nativeState}</span>
      </div>
    )}
  </div>
)}

                
              </div>

              <div className="match-card-divider" />

              <div className="match-card-bottom">{getActionButton(item)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (!isHydrated) {
    return null; // prevents first paint → removes scroll animation
  }

  return (
    <div className="col-lg-9 col-12">
      {result.length === 0 && !pageLoading && (
        <div>No Matching Result Found</div>
      )}
      {result.map((item, index) => (
        <MatchCard
          key={item.id}
          item={item}
          defaultImage={defaultImage}
          lastMatchElementRef={lastMatchElementRef}
          isLast={index === result.length - 1}
          handleSearch={handleSearch}
          bookmarkAnimating={bookmarkAnimating}
          handleToggleBookmark={handleToggleBookmark}
          getActionButton={getActionButton}
          handleViewPhoto={handleViewPhoto}
        />
      ))}

      <CommonContactModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        profileData={{
          photo: contactInfo?.photo,
          fallbackPhoto: defaultImage,
          user_info: {
            register_id: contactInfo?.username,
          },
          phone: contactInfo?.phone,
          type: contactInfo?.type,
          message: contactInfo?.message,
        }}
      />

      {pageLoading && <p>Loading...</p>}
      {error && <p>{error}</p>}
      <MessengerModal
        open={openMessengerModal}
        onClose={() => setOpenMessengerModal(false)}
      />

      <ToastContainer />

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />

      {hasMore && <div ref={lastMatchElementRef} style={{ height: "1px" }} />}
    </div>
  );
};
